module.exports = __webpack_public_path__ + "static/media/ax.63c0fd2b.svg";